<template>
    <main id="display-block"
        class="display-block"
    >
        <!-- 多用一個 component 去包，因應將來會發生的監控地圖互動  -->
        <!-- 地圖 component -->
        <div
            class="emap-container"
            :class="{
                'emap-container--hide': is_atlas || is_monitor,
                'emap-container--monitor': is_monitor && is_monitor_open_emap,
            }"
        >
            <EMapVue v-if="has_got_map_config_from_server"
                ref="emap"
                :origin_selected_products="selected_products"
                :keep_group_list="keep_group_list"
                :multiple_group_list="multiple_group_list"
                :timeless_list="timeless_list"
                :config="config"
                :selected_geomap_products="selected_background_products"
                :information="[]"
                :map_config_from_server="map_config_from_server"
                :is_show_favorites="is_show_favorites"
            />
        </div>
        <!-- 圖輯 component -->
        <AtlasBlock 
            v-if="atlas_loaded" 
            v-show="is_atlas" 
        />
        <!-- 監控 component  -->
        <MonitorBlock 
            v-if="monitor_loaded" 
            v-show="is_monitor"
        />
    </main>
</template>

<script>
    import { mapState } from 'vuex';
    import EMapVue from '@/components/emap/emap.vue';

    export default {
        name: 'DisplayBlock',

        components: {
            EMapVue,
            AtlasBlock: () => import('@/components/atlas/atlas_block.vue'),
            MonitorBlock: () => import('@/components/monitor/monitor_block.vue'),
        },

        props: {
            is_show_favorites: {
                type: Boolean,
                default: true
            },
        },

        data() {
            return {
                atlas_menu_data: {},
                main_menu_selected: 'main-menu-emap',
            }
        },

        computed: {
            ...mapState([
                'client_name',
            ]),

            ...mapState('emap', [
                'has_got_map_config_from_server',
                'map_config_from_server',
                'selected_products',
                'config',
                'keep_group_list',
                'multiple_group_list',
                'timeless_list',
                'selected_background_products',
            ]),

            ...mapState('atlas', [
                'is_atlas',
                'atlas_loaded',
            ]),
            
            ...mapState('monitor', [
                'is_monitor',
                'monitor_loaded',
            ]),

            ...mapState('emap-monitor', [
                'is_monitor_open_emap',
            ])

        },

        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../css/mixin';

    .display-block {
        height: 100vh;

        @include laptop {
            height: var(--app-height);
        }
    }

    .emap-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;

        &--hide {
            display: none;
        }

        &--monitor {
            display: block;
            height: 50%;
        }
    }
</style>
    